import React from 'react';

import { MessagesProvider, Message } from '../Internationalization';

import messages from './messages';

const CompanyPolicy = () => (
  <MessagesProvider messages={messages}>
    <p className="mb-small text-small">
      <a
        href="/CompanyPolicy.pdf"
        target="_blank"
        className="link link-underlined text-color-grey"
      >
        <Message id="label" />
      </a>
    </p>
  </MessagesProvider>
);

export default CompanyPolicy;



// WEBPACK FOOTER //
// ./src/modules/CompanyPolicy/index.js